import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import classnames from 'classnames2';
import { Label } from '../../../Label';
import styles from './Select.Option.Label.scss';
export var SelectOptionLabel = function SelectOptionLabel(props) {
  return React.createElement("div", {
    className: classnames(styles.label, styles["indentation".concat(props.indentLevel)], _defineProperty({}, styles.disabled, props.disabled))
  }, React.createElement(Label, {
    variant: "group",
    disabled: props.disabled
  }, props.text));
};
SelectOptionLabel.defaultProps = {
  indentLevel: 0
};